import { createReducer, on } from '@ngrx/store';
import { initialState, PasswordChangeStatus, UserPasswordState } from './user-password.state';
import { userPasswordActions } from './user-password.actions';

export const userPasswordReducer = createReducer(
  initialState,
  on(userPasswordActions.password_change_page_open, (state): UserPasswordState => {
    return {
      ...state,
      changeStatus: PasswordChangeStatus.InputForm,
      changeFailureResult: null
    };
  }),
  on(userPasswordActions.password_change_start, (state): UserPasswordState => {
    return {
      ...state,
      changeStatus: PasswordChangeStatus.Changing,
      changeFailureResult: null
    };
  }),
  on(userPasswordActions.password_change_success, (state): UserPasswordState => {
    return {
      ...state,
      changeStatus: PasswordChangeStatus.Changed
    };
  }),
  on(userPasswordActions.password_change_failure, (state, { status }): UserPasswordState => {
    return {
      ...state,
      changeStatus: PasswordChangeStatus.ChangeFailed,
      changeFailureResult: status
    };
  })
);
